import type { Options as HighchartsOptions } from 'highcharts';
import { useMemo } from 'react';
import type { BarHighChartProps } from './types';
import { buildBarChartOptions, createBarChartSeries } from './utils';

export const useBarChartOptions = ({
  data,
  variables,
  barsClasses,
  name,
  margins,
  isAxesInvisible,
  hourly,
  unit,
  useUTC,
}: BarHighChartProps): HighchartsOptions => {
  const series = useMemo(
    () => createBarChartSeries({ data, variables, barsClasses, name }),
    [data, variables, barsClasses, name],
  );

  return useMemo(
    () =>
      buildBarChartOptions({
        series,
        margins,
        isAxesInvisible,
        hourly,
        unit,
        useUTC,
      }),
    [series, margins, isAxesInvisible, hourly, unit, useUTC],
  );
};
